<div class="chatbot-container">
  <!-- Chat Panel -->
  @if (chatOpen) {
    <div class="chatbot-panel"
         [class.dragging]="dragging"
         [class.resizing]="resizing"
         [style.width.px]="panelSize.width"
         [style.height.px]="panelSize.height"
         [style.transform]="'translate(' + dragOffset.x + 'px, ' + dragOffset.y + 'px)'">

      <!-- Maniglie di ridimensionamento (bordo sinistro, superiore e angolo) -->
      <div class="chatbot-resize-handle top" (pointerdown)="startResize($event, 'top')"></div>
      <div class="chatbot-resize-handle left" (pointerdown)="startResize($event, 'left')"></div>
      <div class="chatbot-resize-handle corner" (pointerdown)="startResize($event, 'corner')"></div>

      <!-- Header (drag handle) -->
      <div class="chatbot-panel-header"
           (pointerdown)="startDrag($event)">
        <div class="chatbot-panel-header-top">
          <div class="chatbot-panel-header-title">
            <img src="assets/images/chabot/chatbot_ai.jpeg" alt="AI" class="chatbot-logo-sm" />
            <span>{{ 'chatbot.title' | translate }}</span>
          </div>
          <div class="chatbot-panel-header-actions">
            <button mat-icon-button (click)="toggleMaximize()"
                    [matTooltip]="(isExpanded ? 'chatbot.restore' : 'chatbot.maximize') | translate">
              <i-tabler [name]="isExpanded ? 'arrows-minimize' : 'arrows-maximize'" class="icon-18"></i-tabler>
            </button>
            <button mat-icon-button (click)="chatOpen = false">
              <i-tabler name="x" class="icon-18"></i-tabler>
            </button>
          </div>
        </div>
        <button mat-button class="chatbot-new-session-btn" (click)="startNewSession()"
                [disabled]="loading">
          <i-tabler name="refresh" class="icon-16"></i-tabler>
          <span>{{ 'chatbot.new_session' | translate }}</span>
        </button>
      </div>

      <!-- Messages -->
      <div class="chatbot-panel-messages" #messagesContainer>
        @if (messages.length === 0 && !loading) {
          <div class="chatbot-welcome-msg">
            <img src="assets/images/chabot/chatbot_ai.jpeg" alt="AI" class="chatbot-logo-lg" />
            <p>{{ 'chatbot.welcome' | translate }}</p>
          </div>
        }

        @for (msg of messages; track $index) {
          <div class="chatbot-message" [class.user]="msg.role === 'user'" [class.bot]="msg.role === 'bot'">
            @if (msg.role === 'bot') {
              <div class="chatbot-avatar bot-avatar">
                <img src="assets/images/chabot/chatbot_ai.jpeg" alt="AI" class="chatbot-avatar-img" />
              </div>
            }
            @if (msg.role === 'user') {
              <div class="chatbot-avatar user-avatar">
                <img [src]="userAvatar" alt="user" class="chatbot-avatar-img user-avatar-img" />
              </div>
            }
            <div class="chatbot-message-content">
              <div class="chatbot-message-bubble">
                @if (msg.attachments?.length) {
                  <div class="chatbot-attachments">
                    @for (att of msg.attachments; track $index) {
                      @if (att.type === 'image') {
                        <img [src]="att.url" [alt]="att.name" class="chatbot-attachment-image" />
                      } @else if (att.type === 'audio') {
                        <audio [src]="att.url" controls class="chatbot-audio-player"></audio>
                      } @else {
                        <div class="chatbot-attachment-chip">
                          <i-tabler name="file" class="icon-14"></i-tabler>
                          <span>{{ att.name }}</span>
                        </div>
                      }
                    }
                  </div>
                }
                @if (msg.text) {
                  <span>{{ msg.text }}</span>
                }
              </div>
              <span class="chatbot-message-time">{{ msg.timestamp | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
        }

        <!-- Typing indicator -->
        @if (loading) {
          <div class="chatbot-message bot">
            <div class="chatbot-avatar bot-avatar">
              <img src="assets/images/chabot/chatbot_ai.jpeg" alt="AI" class="chatbot-avatar-img" />
            </div>
            <div class="chatbot-message-bubble chatbot-typing">
              <span></span><span></span><span></span>
            </div>
          </div>
        }
      </div>

      <!-- Pending attachments preview -->
      @if (pendingAttachments.length > 0) {
        <div class="chatbot-attachment-preview">
          @for (file of pendingAttachments; track $index) {
            <div class="chatbot-attachment-chip pending">
              <i-tabler [name]="getAttachmentIcon(file)" class="icon-14"></i-tabler>
              <span>{{ file.name }}</span>
              <button mat-icon-button class="remove-att-btn" (click)="removeAttachment($index)">
                <i-tabler name="x" class="icon-12"></i-tabler>
              </button>
            </div>
          }
        </div>
      }

      <!-- Input -->
      <div class="chatbot-panel-input">
        <!-- Hidden file input -->
        <input
          #fileInput
          type="file"
          [accept]="acceptedExtensions"
          multiple
          hidden
          (change)="onFilesSelected($event)"
        />
        <button
          mat-icon-button
          class="attach-btn"
          (click)="fileInput.click()"
          [disabled]="loading || isRecording"
          [matTooltip]="'chatbot.attach_tooltip' | translate">
          <i-tabler name="paperclip" class="icon-20"></i-tabler>
        </button>
        <textarea
          #chatInput
          [(ngModel)]="inputText"
          (input)="autoGrowInput()"
          (keydown.enter)="onEnterKey($event)"
          [placeholder]="'chatbot.placeholder' | translate"
          [disabled]="loading || isRecording"
          class="chatbot-input-field"
          rows="1"
          autocomplete="off"
        ></textarea>
        <!--<button
          mat-icon-button
          class="mic-btn"
          [class.recording]="isRecording"
          (click)="isRecording ? stopRecording() : startRecording()"
          [disabled]="loading"
          [matTooltip]="(isRecording ? 'chatbot.stop_record_tooltip' : 'chatbot.record_tooltip') | translate">
          <i-tabler [name]="isRecording ? 'player-stop' : 'microphone'" class="icon-20"></i-tabler>
        </button>-->
        <button
          mat-icon-button
          class="send-btn"
          (click)="sendMessage()"
          [disabled]="loading || isRecording || (!inputText.trim() && pendingAttachments.length === 0)">
          <i-tabler name="send" class="icon-20"></i-tabler>
        </button>
      </div>

    </div>
  }

  <!-- FAB Button -->
  <button
    mat-fab
    class="chatbot-fab"
    (click)="chatOpen = !chatOpen"
    [matTooltip]="'chatbot.tooltip' | translate"
    matTooltipPosition="left">
    <img src="assets/images/chabot/chatbot_ai.jpeg" alt="AI" class="chatbot-fab-img" />
  </button>
</div>
